import React, { Component } from "react";
import connected from "./connected";
import TimezoneSelect from "../../components/TimezoneSelect";
import FullBtn from "../../components/Buttons/Full";
import s from "./index.css";
class Timezone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timezone: this.props.timezone,
      changed: false
    };
  }

  componentDidMount() {
    this.props.setSystemTimezone();
  }

  updateTimezone(timezone) {
    this.setState({ changed: true, timezone });
  }

  saveTimezone() {
    this.setState({ changed: false });
    this.props.updateTimezone(this.state.timezone);
  }

  render() {
    const { timezone, changed } = this.state;
    return (
      <div className={s.content}>
        <p className="bold m-0 p-2 font-18">Change your time</p>
        <TimezoneSelect
          style={{ height: "calc(100% - 114px)" }}
          timezone={timezone}
          onChange={this.updateTimezone.bind(this)}
        />
        <FullBtn
          fontSize={18}
          className="position-absolute bg-blue text-white text-center py-3 z-index-2 bold"
          style={{ bottom: 0 }}
          disabled={!changed}
          onClick={this.saveTimezone.bind(this)}
        >
          Save
        </FullBtn>
      </div>
    );
  }
}

export default connected(Timezone);



// WEBPACK FOOTER //
// ./src/routes/Timezone/index.js